import { Control, FieldPath, FieldValues } from "react-hook-form";

import { Checkbox } from "src/core/components/ui/checkbox";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "src/core/components/ui/form";

export type ICheckboxOption = {
  id: string;
  label: string;
};

type FormCheckboxMultipleProps<T extends FieldValues> = {
  name: FieldPath<T>;
  label: string;
  required?: boolean;
  control?: Control<T>;
  options: ICheckboxOption[];
  disabled?: boolean;
};

export function FormCheckboxMultiple<T extends FieldValues>({
  name,
  label,
  required = false,
  control,
  options,
  disabled = false,
}: FormCheckboxMultipleProps<T>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ fieldState }) => (
        <FormItem>
          <div className="">
            <FormLabel required={required} className={`${fieldState.invalid ? "text-alert" : ""}`}>
              {label}
            </FormLabel>
          </div>
          <div className="flex flex-row flex-wrap gap-x-20">
            {options.map((option) => (
              <FormField
                key={option.id}
                control={control}
                name={name}
                render={({ field }) => {
                  return (
                    <FormItem key={option.id} className="flex flex-row items-center space-x-10">
                      <FormControl>
                        <Checkbox
                          className={`${fieldState.invalid ? "border-alert" : ""}`}
                          checked={field.value?.includes(option.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, option.id])
                              : field.onChange(
                                  field.value?.filter((value: string) => value !== option.id)
                                );
                          }}
                          disabled={disabled}
                        />
                      </FormControl>
                      <FormLabel className="mt-[2px]">{option.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
